// ../internal/src/components/beacons/use-beacons.tsx
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment SponsoredContentBeaconsFragment on SponsoredContentBeacons {\n    renderBeacons\n    viewabilityBeacon\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql } from "@apollo/client";
import { useLoggerEvents } from "@shared-ui/logger-context";
// ../internal/src/components/utils/logger-utils.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
    FAIL_TO_SEND_BEACON_USING_BEACON_API: new SystemEvent(SystemEventLevel.WARN, "FAIL_TO_SEND_BEACON_USING_BEACON_API" /* FAIL_TO_SEND_BEACON_USING_BEACON_API */ )
};
// ../internal/src/components/beacons/use-beacons.tsx
var SponsoredContentBeaconsFragment = gql(_templateObject());
var fireBeacon = function(beacon, events) {
    try {
        if (!navigator.sendBeacon(encodeURI(beacon))) {
            events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({});
        }
    } catch (error) {
        events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({
            error: error
        });
    }
};
var useBeacons = function(beacons) {
    var loggerEvents = useLoggerEvents(EVENTS);
    React.useEffect(function() {
        if (beacons) {
            var _beacons_renderBeacons;
            (_beacons_renderBeacons = beacons.renderBeacons) === null || _beacons_renderBeacons === void 0 ? void 0 : _beacons_renderBeacons.forEach(function(impression) {
                fireBeacon(impression, loggerEvents);
            });
        }
    }, []);
};
var useClickBeacon = function() {
    var loggerEvents = useLoggerEvents(EVENTS);
    return function(link) {
        if (link) {
            fireBeacon(link, loggerEvents);
        }
    };
};
var useMesoBeaconFramework = function(beacons) {
    React.useEffect(function() {
        if (beacons) {
            beacons.forEach(function(renderBeaconUrl) {
                window.meso = window.meso || {};
                window.meso.beacons = window.meso.beacons || [];
                window.meso.beacons.push({
                    type: "beacon",
                    url: renderBeaconUrl
                });
            });
        }
    }, []);
};
// src/components/use-beacons-wrapper/use-beacons-wrapper.tsx
var useClickBeaconWrapper = useClickBeacon;
var useBeaconsWrapper = useBeacons;
var useMesoBeaconFrameworkWrapper = useMesoBeaconFramework;
export { useBeaconsWrapper, useClickBeaconWrapper, useMesoBeaconFrameworkWrapper };
//# sourceMappingURL=index.js.map